import React from 'react'
import uuid from 'uuid';
import classNames from 'classnames';

import CheckBox from './../PageLayout/CheckBox';
import {injectIntl} from "react-intl";

export const FormField = (props) => {
  const {input, style, onClick, label, type, disabled, meta: {touched, error}, percent, labelAfter} = props;

  const inputId = uuid.v4();
  const renderLabel = label ? (
    <label htmlFor={inputId}
           className={"ui-input3-title" + (disabled ? " ui-input3-title--disabled" : "")}>{label}</label>
  ) : null;
  return (
    <div className="acc-field">
      {label && labelAfter ? (
        <div className="flex flex--center flex--start">
          {renderLabel}
          {labelAfter}
        </div>
      ) : renderLabel}
      <input {...input}
             style={style || {}}
             id={inputId}
             type={type}
             disabled={disabled}
             onClick={onClick || null}
             className={classNames("ui-input3", {"field-error": touched && error})}/>
      {percent ? <span style={{
        display: "inline-block",
        float: "right",
        position: "absolute",
        fontSize: "25px",
        marginLeft: "3px"
      }}>%</span> : null}
    </div>);
};

export const CheckBoxFieldInjected = (props) => {
  const {input, labelEnabled, labelDisabled, type, disabled, onChecked, doubleMargin = false, intl, tool} = props;
  return (
    <div className={doubleMargin ? "acc-checkbox" : "acc-field"}>
      <CheckBox checked={input.value}
                text={input.value
                  ? (labelEnabled || intl.formatMessage({id: "checkbox.enabled"}))
                  : (labelDisabled || intl.formatMessage({id: "checkbox.disabled"}))}
                type={type} disabled={disabled} onChecked={checked => onChecked(input, checked, tool)}/>
    </div>
  )
};

export const FormCheckBoxField = injectIntl(CheckBoxFieldInjected)

export const FormTextAreaField = ({input, style, label, disabled, placeholder, meta: {touched, error}}) => {
  const inputId = uuid.v4();
  return (
    <div className="acc-field">
      {label ? <label htmlFor={inputId} className={"ui-input3-title" + (disabled ? " ui-input3-title--disabled" : "")}>{label}</label> : null}
      <textarea className={classNames("ui-input3 ui-input3--textarea", {"field-error": touched && error})}
                style={style || {}} {...input} id={inputId} disabled={disabled} placeholder={placeholder}>
        {input.value}
      </textarea>
    </div>
  );
};

export const HiddenField = ({input}) => {
    return (
      <input type='hidden' {...input}/>
    )
};

export const required = value => value && value.length ? undefined : 'Required';

export const requiredWithLength = (min, max) => value => (value && value.length >= min && value.length <= max) ? undefined : 'Required';

export const conditionalRequired = (condition) => condition ? required : () => undefined;

// export const phoneValidator = value => value ? (/^[+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value) ? undefined : 'Wrong format') : undefined;
export const phoneValidator = value => value ? (/^[+]?[\d-]{10,15}$/im.test(value) ? undefined : 'Wrong format') : undefined;

export const requiredPhoneValidator = value => /^[+]?[+]?[\d-]{10,15}$/im.test(value) ? undefined : 'Required';

